import React, { useContext, useEffect} from 'react';
import {FilterContext} from '../context/filterContext';
import Form from 'react-bootstrap/Form';
import {getDataApi} from '../api/getApiData';
import {UserContext} from '../context/userContext';
import {AuthContext} from '../context/authContext';
import classNames from 'classnames';
import '../../../assests/css/favorites.scss';

export interface favouritesFilterProps {
    checked: boolean,
    onChange: (checked: boolean)=> void,
    disableFilter?: boolean
}

export default function FavoritesFilter(props: favouritesFilterProps) {

    const {checked, onChange, disableFilter} = props;

    const {filterData, setFilterData} = useContext(FilterContext);
    const {data} = useContext(UserContext);
    const {accounts} = useContext(AuthContext);

    const handleChecked = () => {
        onChange(checked);
    }

    const getFavourites = async () => {
        const res = await getDataApi(`Favourites/?$filter=userId eq ${data.userId}`,
            accounts);
        setFilterData({...filterData, favourites: res}, 'favorites');
    }

    useEffect(()=> {
        getFavourites();
    }, []);

    return (
        <div className={classNames('favorites-filter-container',
            disableFilter? 'disable-filter': '')}>
            <span className="favorites-text">Show Favourites Only</span>
            <span className="favorites-toggle-btn">
                <Form>
                    <Form.Check type="switch" checked={checked}
                        onChange={disableFilter? ()=> null: handleChecked}/>
                </Form>
            </span>
        </div>
    );

}